import { render, staticRenderFns } from "./CompFooterPc.vue?vue&type=template&id=3d534291&scoped=true&"
import script from "./CompFooterPc.vue?vue&type=script&lang=js&"
export * from "./CompFooterPc.vue?vue&type=script&lang=js&"
import style0 from "./CompFooterPc.vue?vue&type=style&index=0&id=3d534291&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d534291",
  null
  
)

export default component.exports